export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('facebook_widget', {
    label: 'Facebook',
    category: 'Social',
    content: {
      type: 'facebook_widget',
      resizable: {
        step: 0.2,
        minDim: 10,
        currentUnit: 1,
        autoHeight: true
      },
      style: {
        width: '500px',
        height: '600px',
        transform :"scale(1.2)"
      }
    },
    attributes: {
      class: 'fa fa-facebook' //icon in the panel
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/facebook/blocks.js